<section class="validate-arm-pool-page">
  <div class="validate-arm-pool-modal-backdrop">
    <div class="validate-arm-pool-modal" role="dialog" aria-labelledby="jumega-report-title">
      <div class="validate-arm-pool-modal-header">
        <h2 id="jumega-report-title" class="validate-arm-pool-modal-title">JU Mega Report</h2>
      </div>
      <div class="validate-arm-pool-modal-body">
        <div class="validate-arm-pool-alert" role="status" aria-live="polite">
          <div class="validate-arm-pool-alert-icon-wrap">
            <i class="bi bi-info-circle validate-arm-pool-alert-icon" aria-hidden="true"></i>
          </div>
          <div class="validate-arm-pool-alert-content">
            <p class="validate-arm-pool-alert-text">
              Upload a text or Excel file with CUSIP, Original Face, and Current Face values to
              generate a JU Mega report.
            </p>
          </div>
        </div>

        @if (showValidationAlert) {
          <div
            class="validate-arm-pool-alert"
            [class.validate-arm-pool-alert-success]="isSuccessAlert"
            [class.validate-arm-pool-alert-danger]="!isSuccessAlert"
            role="alert"
            aria-live="assertive"
          >
            <div class="validate-arm-pool-alert-icon-wrap">
              <i
                class="bi validate-arm-pool-alert-icon"
                [class.bi-check-circle-fill]="isSuccessAlert"
                [class.bi-exclamation-circle-fill]="!isSuccessAlert"
                aria-hidden="true"
              ></i>
            </div>
            <div class="validate-arm-pool-alert-content">
              <p class="validate-arm-pool-alert-text">{{ validationAlertMessage }}</p>
            </div>
          </div>
        }

        <div class="validate-arm-pool-input-item">
          <div class="validate-arm-pool-input-item-container">
            <label class="validate-arm-pool-input-label" for="jumega-file">
              <span>JU Mega File</span><span class="validate-arm-pool-required-asterisk">*</span>
            </label>
            <div class="validate-arm-pool-input-field-group">
              <div
                class="validate-arm-pool-file-picker-row"
                [class.validate-arm-pool-file-picker-row-invalid]="hasFileValidationError"
              >
                <input
                  #jumegaFileInput
                  id="jumega-file"
                  class="validate-arm-pool-file-input"
                  type="file"
                  accept=".txt,.csv,.xls,.xlsx"
                  (change)="onFileSelected($event)"
                />
                <label class="validate-arm-pool-choose-file" for="jumega-file">Choose File</label>
                <span class="validate-arm-pool-selected-file">{{ selectedFileName }}</span>
              </div>
            </div>
            <div class="validate-arm-pool-input-feedback">
              <p class="validate-arm-pool-input-feedback-text">
                Formats accepted: txt, csv, xls, xlsx
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="validate-arm-pool-modal-footer">
        <div class="validate-arm-pool-modal-footer-actions">
          <button
            type="button"
            class="validate-arm-pool-btn validate-arm-pool-btn-outline"
            (click)="onReset(jumegaFileInput)"
          >
            Reset
          </button>
          <button
            type="button"
            class="validate-arm-pool-btn validate-arm-pool-btn-primary"
            [disabled]="isSubmitting"
            (click)="onEmailReport()"
          >
            Email Report
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
